import { z } from 'zod';
import {
    type ControlSocketKind,
    type NodeSocketCfg,
} from './base-node';
import { baseConnectionCfgSchema, connectionNodeConfigSchema } from './connection.zod';

export const udpConnectionCfgSchema = connectionNodeConfigSchema(baseConnectionCfgSchema.extend({
    kind: z.literal('udpConnection'),
    controlValues: baseConnectionCfgSchema.shape.controlValues.merge(z.object({
    })),
}));
interface UdpConnectionCfgSchema extends z.infer<typeof udpConnectionCfgSchema> {}

export const udpConnectionSocketCfg = {
    controlSockets: {
        outputs: () => {
            const ret: Record<'messageReceieved', ControlSocketKind> = {
                messageReceieved: 'event',
            };
            return ret;
        },
        inputs: () => {
            const ret: Record<'sendMessage', ControlSocketKind> = {
                sendMessage: 'event',
            };
            return ret;
        },
    },
    dataSockets: {
        outputs: () => {
            const ret: {
                receivedMessage: 'string';
            } = {
                receivedMessage: 'string',
            };
            return ret;
        },
        inputs: () => {
            const ret: {
                messageToSend: 'string';
            } = {
                messageToSend: 'string',
            };
            return ret;
        },
    },
} satisfies NodeSocketCfg<UdpConnectionCfgSchema>;
